import { render } from "./App.vue?vue&type=template&id=56a09d04&bindings={\"sidebarClass\":\"options\",\"handleExpand\":\"options\",\"focusSubmenu\":\"options\",\"handleHideSubmenu\":\"options\",\"handleHamburgerClick\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script